import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileCompanyLogoAPI } from '../../../../api'
import { userData } from 'features/user/store'
import {
  PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_REQUEST,
  PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_SUCCESS,
  PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_FAILED,
} from './actionTypes'

export const profileEmployerCompanyLogoRemovePA = createPromiseAction(
  PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_REQUEST,
  PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_SUCCESS,
  PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_FAILED
)()

function* remove(action) {
  try {
    const response = yield call(profileCompanyLogoAPI.deleteLogo)
    const { data } = response

    yield put(profileEmployerCompanyLogoRemovePA.success({}))

    yield put(userData.updateEmployerProfile({ company_logo: null }))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* removeSaga() {
  yield takeEvery(profileEmployerCompanyLogoRemovePA.request, remove)
}
